import styled from '@emotion/styled'

export const Header = styled.div``

export const Content = styled.div(({ bottom, positionOffset }) => {
  const position = positionOffset ? 'absolute' : 'relative'
  return `
    position: ${position};
    ${bottom ? `bottom: 55px;` : ''}
    width: 100%;
    padding-right: 30px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track:vertical {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
      border-radius: 5px;
    }

    ::-webkit-scrollbar-thumb:vertical {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    }
  `
})

export const Footer = styled.div((props) => {
  const { sAndGDrawerDivider, sAndGDrawerBackground } = props.theme
  return `
    background-color: ${sAndGDrawerBackground};
    border-top: 1px solid ${sAndGDrawerDivider};
    flex-shrink: 0;
    width: 100%;

    .ant-row-flex {
      margin: 0 !important;
      width: 100% !important;
    }
  `
})
